module.exports = __webpack_public_path__ + "static/img/25c.9e864bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/25c.jpg
// module id = MTUh
// module chunks = 0